import InnerComponent from '@Components/Purchase/Expense/ExpenseHome';
import orgContainer from '@Components/AppContainer';

const ExpenseHome = () => ((orgContainer(InnerComponent)));
export default ExpenseHome;
